export enum ActivationStatusFilterEnum {
  activated = "activated",
  notActivated = "not_activated",
  all = "all",
}

export enum PortoutStatusFilterEnum {
  ported = "ported",
  notPorted = "not_ported",
  pendingPortout = "pending_portout",
  all = "all",
}
